import React, { useState } from 'react'
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button } from '@mui/material'
import moment from 'moment'

const EditNoteDialog = ({ open, onClose, onEdit, note }) => {
  const [noteContent, setNoteContent] = useState(null)

  const handleClick = () => {
    onEdit({ ...note, content: noteContent })
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Edit Note</DialogTitle>
      <DialogContent>
        <Alert severity="info">To Save edited notes, click save Property</Alert>
        <TextField
          margin="dense"
          label="Note"
          type="text"
          fullWidth
          defaultValue={note?.content}
          multiline
          rows={3}
          onChange={(event) => setNoteContent(event.target.value)}
        />
        <TextField margin="dense" label="Created by" type="text" fullWidth value={note?.created_by} disabled />
        <TextField
          margin="dense"
          label="Created at"
          type="text"
          fullWidth
          value={note?.created_at ? moment(note.created_at).format('LLL') : '-'}
          disabled
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleClick}>Edit</Button>
      </DialogActions>
    </Dialog>
  )
}
export default EditNoteDialog
